<template>
    <div class="ur-data-grid__edit__element ur-data-grid__edit__mask-field" @mousedown.stop="()=>{}">
<!--        <input class="ur-data-grid__edit__element__input-->
<!--                      ur-data-grid__edit__mask-field__placeholder"-->
<!--               tabindex="-1" :placeholder="$_placeholder"/>-->
        <input class="ur-data-grid__edit__element__input
                      ur-data-grid__edit__mask-field__input"
               :placeholder="$_placeholder"
               ref="input" :tabindex="tabindex" :disabled="disabled"
               :value="currVal" @input="onInput"
               v-on="{...$listeners, input:()=>{}}"/>
    </div>
</template>

<script>
// TODO 1. key.enter to save?
export default {
    name: 'urDataGridEditMaskField',
    props: {
        value      : {type: [String,Number,Object]},
        pattern    : {type: String, required: true},
        placeholder: {type: String},
        disabled   : {type: Boolean, default: false},
        tabindex   : {type:[Number,String]},
    },
    data() { return {
        currVal: '', // value for "input" element
    }},
    watch: {
        value: {immediate: true, handler(val, old) {
            this.currVal = val; // when input comes
            // 2. keep cursor
            var $i = this.$refs.input;
            if($i) {
                var pos = {st : $i.selectionStart, ed : $i.selectionEnd}
                this.$nextTick(() => {
                    $i.setSelectionRange(pos.st, pos.ed);
                })
            }
        }}
    },
    computed: {
        $_placeholder() {
            return this.placeholder || this.pattern
        },
        inputStyle() {
            const lPAD = 8, cWIT = 7;
            var style= {};
            var w = this.currVal?this.currVal.length:0,
                wit= ~~(lPAD+(w)*cWIT); // for input 14px;
            style.background = `linear-gradient(90deg, #FFF ${wit}px, rgba(0,0,0,0) 0px)`;
            
            return style
        }
    },
    methods: {
        onInput(e) {
            // 0. prepare values
            var v = e.target.value, p = this.pattern, $i = this.$refs.input;
            // 0.1 keep selection
            var pos = {
                st : $i.selectionStart,
                ed : $i.selectionEnd
            }
            
            // 1. DO Masking.
            var maskText = fn_convMask(v, p, pos);
            // 2. set text & cursor to Input
            $i.value = maskText;/// make inf.loop?
            if(!isMask(p[pos.st]) && (e.inputType == 'deleteContentForward')) {
                pos.st++;pos.ed++; 
            }
            $i.setSelectionRange(pos.st, pos.ed);
            // 3. set value & emit
            //this.currVal = maskText;
            this.$emit('input',maskText);
        },
        focus(opts) {
            this.$refs.input.focus(opts);
        },
        selectAll() {
            this.$refs.input.select();
        }
    },
};


//============================================
//-- Utility of Mask Field
var maskChars = {
    '#': { test: ch => '0'<=ch && ch<='9',
           convert: ch => ch},
    'A': { test: char => char.match(/[A-Z]/i),
           convert: char => char.toUpperCase()},
    'a': { test: char => char.match(/[a-z]/i),
           convert: char => char.toLowerCase()},
    'N': { test: char => char.match(/[0-9A-Z]/i),
           convert: char => char.toUpperCase()},
    'n': { test: char => char.match(/[0-9a-z]/i),
           convert: char => char.toLowerCase()}
};
    
function fn_convMask(text, mask, pos) {
    
    // 1. prepare data
    const masked = mask.split('');
    var textIdx = 0, maskIdx = 0;
    var rtn = '', m, c, idx;
    
    // 2. build keyin char array
    var textArr = [];
    while(text[textIdx]) {
        m = masked[maskIdx++] || m;
        if (!isMask(m)) {continue;}
        while(c = text[textIdx++]) {
            if(maskChars[m].test(c)) {
                textArr.push(c);
                break;
            }
        }
    }
    // 2. do with maks array.
    for(var i=0, ii=masked.length; i<ii && textArr.length ; i++) { // shift makes textArr shorter
        m = masked[i];
        if(isMask(m)) {
            rtn+= maskChars[m].convert(textArr.shift());
        } else {
            /*NOSONAR*/if(m==='\\') {m=masked[++i]}
            rtn+=m;
        }
    }
    // 3. Post...work
    // 3.1 Add non mask char
    if(rtn.length < mask.length) {
        idx = rtn.length
        while(!!(m=mask[idx++])&&!isMask(m)) {
            rtn+=m;
        }
    }
    
    // 4. backword?
    var loc = pos.st-1;
    if(!isMask(mask[loc]) && text.length === rtn.length) {
        rtn = rtn.slice(0, rtn.length-1);
    }
    
    return rtn;
}

function isMask(ch) {
    return maskChars.hasOwnProperty(ch);
}

</script>


